import { gql } from "@apollo/client";

const UPGRADE_SUBSCRIPTION = gql`
  mutation updateSubscription(
    $subscriptionId: ID!
    $newPlanId: ID!
    $newQuantity: Int!
    $billingCycleInterval: String!
    $billingCycleIntervalCount: Int!
    $newPackageName: String!
    $accessToken: String
  ) {
    updateSubscription(
      subscriptionId: $subscriptionId
      newPlanId: $newPlanId
      newQuantity: $newQuantity
      billingCycleInterval: $billingCycleInterval
      billingCycleIntervalCount: $billingCycleIntervalCount
      newPackageName: $newPackageName
      accessToken: $accessToken
    ) {
      success
      error
      result {
        id
        status
        maxAgents
        new_plan
        new_plan_status
        current_period_end
        items {
          id
          price
          quantity
        }
      }
    }
  }
`;

export default UPGRADE_SUBSCRIPTION;
